import React from "react";
import { Layout, ConfigProvider } from "antd";

import { Logout, LanguageSelector } from "../../components/Admin/AdminLayout";
import { Chatbot } from "../../components/Chatbot/Chatbot";

import "./AdminLayoutTop.scss";

const { Header, Content } = Layout;

const reviShellTheme = {
  token: {
    colorPrimary: "#2088A0",
    colorInfo: "#2088A0",
    colorLink: "#2088A0",
    borderRadius: 14,
    colorBgLayout: "#F6FAFB",
    colorBgContainer: "#FFFFFF",
  },
};

export function AdminLayoutTop({ children }) {
  return (
    <ConfigProvider theme={reviShellTheme}>
      <div className="admin-layouttop">
        <Layout className="admin-layouttop__layout">
          <Header className="admin-layouttop-topheader">
            <div className="admin-layouttop-topheader__inner">
              <div className="admin-layouttop-topheader__spacer" />
              <LanguageSelector />
              <Logout />
            </div>
          </Header>

          <Content className="admin-layout__right-topcontent">
            {children}
          </Content>
        </Layout>

        <Chatbot />
      </div>
    </ConfigProvider>
  );
}
